import { union, difference } from 'libraries/lodash'
import { SET_SELECTED_DEALS, SET_SELECTED_DEAL_TYPE } from './types'
import { AppDispatch, RootState } from 'redux/store'

export const setSelectedDeals = ({ select, deselect, dealType }: { select: string[], deselect: string[], dealType: string }) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const {
      dealwatch: {
        selectedDeals: currentlySelectedDeals,
        selectedDealType: currentDealType
      }
    } = getState()

    // join select with currently selected, then find the difference between that and deselect
    const selectedDeals = difference(
      union(currentlySelectedDeals, select),
      deselect
    )

    if (currentDealType === null || currentDealType === dealType) {
      dispatch({
        type: SET_SELECTED_DEALS,
        selectedDeals
      })
    }

    if (currentDealType === null && selectedDeals.length > 0) {
      dispatch({ type: SET_SELECTED_DEAL_TYPE, dealType })
    } else if (selectedDeals.length === 0) {
      dispatch({ type: SET_SELECTED_DEAL_TYPE, dealType: null })
    }
  }
}

export const clearSelectedDeals = () => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: SET_SELECTED_DEALS, selectedDeals: [] })
    dispatch({ type: SET_SELECTED_DEAL_TYPE, dealType: null })
  }
}
